import { FC } from "react";
import { BrowserRouter } from "react-router-dom";
import App from "~/App";
import { ThemeStoreProvider } from "~/stores/themeStore";
import { LayoutConfigProvider } from "~/stores/layoutConfig";
import { AuthStoreProvider } from "~/stores/authStore";

interface IProps {}

const composeProviders =
  (...providers: any[]) =>
  (Child) =>
  (props) =>
    providers.reduce(
      (acc, Provider) => <Provider>{acc}</Provider>,
      <Child {...props} />
    );

// Tạo WrappedApp không bao gồm LayoutConfigProvider
const WrappedApp = composeProviders(ThemeStoreProvider, AuthStoreProvider)(App);

const AppRoot: FC<IProps> = () => {
  return (
    <BrowserRouter>
      <LayoutConfigProvider>
        <WrappedApp />
      </LayoutConfigProvider>
    </BrowserRouter>
  );
};

export default AppRoot;
// export default process.env.NODE_ENV === "development" ? hot(AppRoot) : AppRoot
